<aw-add-boxes-to-contract [contract]="data" (saved)="dialogRef.close(true)"
    (canceled)="dialogRef.close(false)"></aw-add-boxes-to-contract>